var form = {
    ids: ["primaryAge", "spouseAge", "citizenshipCountry", "coverageArea"],
    fields: {
        "primaryAge": {
            $el:"",
            value:"",
            validate:["required","numbers","notPrimaryMinorAge"]
        },
        "spouseAge": {
            $el:"",
            value:"",
            validate:["numbers","notMinorAge"]
        },
        "citizenshipCountry": {
            $el:"",
            value:"",
            validate:["required"]
        },
        "coverageArea": {
            $el:"",
            value:"",
            validate:["required"]
        }
    },
    isFormSubmitted: false,
    queryFields: {
        primaryAge: null,
        spouseAge: null,
        numChildren: '',
        numChildren10_17: '',
        numChildrenUnder10: '',
        citizenshipCountry: '',
        coverageArea:  '',
        homeCountry: '',
        mailingState: '',
        physicalPresenceState: '',
        section: 'multitrip'
    },
    spinnerOpts: {
        lines: 11 // The number of lines to draw
        , length: 25 // The length of each line
        , width: 6 // The line thickness
        , radius: 21 // The radius of the inner circle
        , scale: 0.35 // Scales overall size of the spinner
        , corners: 1 // Corner roundness (0..1)
        , color: '#fff' // #rgb or #rrggbb or array of colors
        , opacity: 0.45 // Opacity of the lines
        , rotate: 0 // The rotation offset
        , direction: 1 // 1: clockwise, -1: counterclockwise
        , speed: 1.4 // Rounds per second
        , trail: 60 // Afterglow percentage
        , fps: 20 // Frames per second when using setTimeout() as a fallback for CSS
        , zIndex: 2e9 // The z-index (defaults to 2000000000)
        , className: 'spinner' // The CSS class to assign to the spinner
        , top: '50%' // Top position relative to parent
        , left: '50%' // Left position relative to parent
        , shadow: false // Whether to render a shadow
        , hwaccel: true // Whether to use hardware acceleration
        , position: 'absolute' // Element positioning
    },
    init: function(){
        var formIds = this.ids;
        var formFields = this.fields;
        for(var i = 0, formlength = formIds.length ; i < formlength ; i++) {
            formFields[formIds[i]].$el = document.querySelector("#"+formIds[i]);
        }

        var $formBtn = document.querySelector(".quote-form-button");
        $formBtn.addEventListener("click", this.onSubmit);

        if($(".c-Widget__horizontal").length){
            this.spinnerOpts.scale = 0.25;
        }

        //initialize Validation fields
        this.validation(true);

        let removeChat = setInterval(() => {
            const chatFrame = document.getElementById('fc_frame')
            if(chatFrame) {
                chatFrame.style.display = 'none';
                clearInterval(removeChat);
            };
        }, 100);
    },
    validate: {
        fields:{},
        invalid: false,
        submitted: false
    },
    validation: function(initialize) {
        var fields = this.fields;
        var _this = this;

        //creating fields and validation parameters.
        if(initialize) {
            for(var key in fields) {
                this.validate.fields[key]= {
                        invalid:false
                };
                var valiKeys = fields[key].validate.filter(function(item){
                    _this.validate.fields[key][item] = true;
                });
            }
        } else {
            var fields = this.validate.fields;

            //Traversing into each validation field items and setting the boolean flag.
            var parentInvalid = false;
            for(var field in fields) {
                var flagPerField = false;
                for(var key in fields[field]) {
                    this.fields[field].value = this.fields[field].$el.value;
                    var fieldValue = this.fields[field].$el.value;
                    if(key == "required") {
                        if(fieldValue && fieldValue.trim() != '') {
                            fields[field][key] = true;
                        } else {
                            fields[field][key] = false;
                        }
                    }
                    if(key == "numbers" && fieldValue && fieldValue.trim() != '') {
                        fields[field][key] = /^\d+$/.test(fieldValue) && parseInt(fieldValue) > 0;
                    } else if(key == "numbers") {
                        fields[field][key] = true;
                    }
                    if(key == "notPrimaryMinorAge" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' && this.fields['spouseAge'].$el.value) {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '') {
                            fields[field][key] = commonFunctions.notPrimaryMinorAge(this.fields["primaryAge"].$el.value, this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                        else if(key == "notPrimaryMinorAge"){
                        fields[field][key] = true;
                    }
                    if(key == "notMinorAge" && this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' && fields['primaryAge']['notPrimaryMinorAge']) {
                        if(this.fields[field].$el.value && this.fields[field].$el.value.trim() != '' ) {
                            fields[field][key] = commonFunctions.notMinorAge(this.fields["spouseAge"].$el.value, this.fields[field].$el.value);
                        }else {
                            fields[field][key] = false;
                        }
                    }
                        else if(key == "notMinorAge"){
                        fields[field][key] = true;
                    }
                    var $errorEl = document.querySelector("." + field +  ".error [val-" + key + "]");
                    if(!fields[field][key] && key !== 'invalid') {
                        if($errorEl) $errorEl.style.display = "block";
                        flagPerField = true;
                    } else {
                        if($errorEl) $errorEl.style.display = "none";
                    }
                }
                fields[field].invalid = flagPerField ? true : false;
                if(fields[field].invalid) {
                    parentInvalid = true;
                }
            }
            this.validate.fields = fields;
            this.validate["invalid"] = parentInvalid;
        }
    },
    onSubmit: function(e) {
        var _this = form;
        _this.validation();
        var isAlreadySubmitted = false;

        if(_this.isFormSubmitted == false) {
            _this.ids.forEach((item)=>{
                if(item != "citizenshipCountry" || item != "coverageArea") {
                    $("#"+ item).on('keypress', (e)=>{
                        $(".error." + e.currentTarget.id).css("display", "none");
                    });
                    $("#"+ item).on('blur', (e)=>{
                        $(".error." + e.currentTarget.id).css("display", "block");
                        _this.validation();
                    });
                }
            });
            $("#citizenshipCountry").on("change", ()=>{
                _this.validation();
            });
        }

        _this.isFormSubmitted = true;

        var $serverErrorElm = document.querySelector(".server-error.error");
        $serverErrorElm.style.display = "none";
        if(!_this.validate.invalid) {
            _this.queryFields = {
                primaryAge: _this.fields.primaryAge.value,
                spouseAge: _this.fields.spouseAge.value || -1,
                numChildrenUnder10: 0,
                numChildren10_17: 0,
                citizenshipCountry: _this.fields.citizenshipCountry.value,
                coverageArea: _this.fields.coverageArea.value,
                mailingState: 'OutsideUSA',
                homeCountry: 'USA',
                physicalPresenceState: 'OutsideUSA',
                section: 'multitrip'
            };

            //ajax using jQuery
            var urlMultiTrip = '/api/compare/multitrip';
            
            var clientURL = window.location.href;
            var getIndex = clientURL.indexOf("?");
            var query = "";
            if (getIndex > -1) {
                query = clientURL.substring(getIndex, clientURL.length);
            }
            if (query && query != "") {
                urlMultiTrip += query;
            }

            var xhr = new XMLHttpRequest();
            xhr.open("POST", urlMultiTrip, true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.setRequestHeader('Accept', 'application/json');
            xhr.send(JSON.stringify(_this.queryFields));
            document.querySelector("button.quote-form-button .btn-text").style.display = "none";
            document.querySelector("button.quote-form-button #spinner").style.display = "inline-block";

            //initialize spinner
            var target = document.getElementById('spinner');
            var spinner = new Spinner(_this.spinnerOpts).spin(target);

            xhr.onreadystatechange = function() {
                document.querySelector("button.quote-form-button #spinner").style.display = "none";
                document.querySelector("button.quote-form-button .btn-text").style.display = "inline-block";
                if((this.readyState==3 || this.readyState==4) && this.status==200 && !isAlreadySubmitted) {
                    isAlreadySubmitted = true;
                    var responseBody = JSON.parse(xhr.responseText);
                    if(responseBody.status==="error") {
                        $serverErrorElm.innerHTML = "<h4 class='c-Server-errors__heading'>Error!</h4>";
                        if(responseBody.data.hasOwnProperty("allErrorMessages") || responseBody.data.hasOwnProperty("globalErrors")) {
                            var errorMessages = responseBody.data.allErrorMessages || responseBody.data.globalErrors;
                            $serverErrorElm.style.display="block";
                            for(var i = 0, errorLength = errorMessages.length; i < errorLength; i++) {
                                var $p=document.createElement("p");
                                var message = errorMessages[i].hasOwnProperty("message") ? errorMessages[i].message :  errorMessages[i];
                                $p.innerHTML = message;
                                $serverErrorElm.append($p);
                            }
                        } else if (responseBody.data.hasOwnProperty("noPlansFound") && responseBody.data.noPlansFound) {
                            $serverErrorElm.style.display = "block";
                            $serverErrorElm.innerHTML = "<p>No Plans Found!</p>";
                        }
                    } else if(responseBody.status==="success") {
                        $serverErrorElm.style.display="none";
                        window.open(responseBody.data.redirectToBN, "_blank");
                    }
                }
            }
        }
    }
};

form.init();
var commonFunctions = {
    notPrimaryMinorAge: function(primAge, spouAge) {
        //primAge Being the primary age
        //spouAge being the spouse age
        var isPast = false;       
        if(primAge && spouAge && spouAge != ''){
            if(primAge < 18) {
                isPast = true;       
            } else{
                isPast = false;
            }
        }
        return !isPast;
    },
    notMinorAge: function(primAge, spouAge) {
        //primAge Being the primary age
        //spouAge being the spouse age
        var isSpouseMinor = false;       
        if(primAge && spouAge && spouAge != ''){
            if(spouAge !== -1 && spouAge < 18) {
                isSpouseMinor = true;
            
            } else{
                isSpouseMinor = false;
            }
        }
        return !isSpouseMinor;
    },
}

function formatChat() {
    const chatFrameStyles = [
        ['height', '100%!important'],
        ['width', '100%!important'],
        ['minHeight', '100px!important'],
        ['maxHeight', '100vh!important'],
        ['right', '0!important'],
        ['bottom', '0!important'],
        ['overflow', 'hidden'],
    ]

    const chatFrame = document.getElementById('fc_frame');
    chatFrameStyles.forEach( x => chatFrame.style[x[0]] = x[1]);
}
